import { BehaviorSubject } from '../BehaviorSubject';
import { ConnectableObservable } from '../observable/ConnectableObservable';
export function publishBehavior(initialValue) {
    const subject = new BehaviorSubject(initialValue);
    return (source) => new ConnectableObservable(source, () => subject);
}
//# sourceMappingURL=publishBehavior.js.map